import { Typography } from '@material-ui/core';
import React from 'react';
import { ArrowBackIcon } from '../../sharedcomponents/inputs/svg-icons/CustomSvgIcons';
import { usePaymentCardMethodStyles } from '../css/usePaymentCardMethodStyles';

const PaymentCardMethodHeader = props => {
    const styleClass = usePaymentCardMethodStyles();
    const handleToback = () => {
        console.log('current step ', props.currentStep);
        props.handleBack();
    };

    const handleSepaAndDDBack = () => {
        props.setHeader('Payment Details');
        props.handleNext(1);
    };
    return (
        <div className={styleClass.headerPaymentContainer}>
            {!props.center && (
                <div
                    aria-label={
                        props.currentStep === 0 ? 'Back to dashboard' : 'Back to payment details'
                    }
                >
                    <ArrowBackIcon
                        className={'payment-header-back-icon'}
                        onClick={
                            props.currentStep === 3 || props.currentStep === 4
                                ? handleSepaAndDDBack
                                : handleToback
                        }
                        tabIndex={0}
                        onKeyDown={e => {
                            if (e.key === 'Enter' || e.key === '') {
                                e.preventDefault();
                                if (props.currentStep === 3 || props.currentStep === 4) {
                                    handleSepaAndDDBack();
                                } else {
                                    handleToback();
                                }
                            }
                        }}
                        aria-label={
                            props.currentStep === 0
                                ? 'Back to dashboard'
                                : 'Back to payment details'
                        }
                    />
                </div>
            )}
            <div className='payment-header-text' id={props.id}>
                <p style={props.center ? { textAlign: 'center', width: '100%' } : {}}>
                    <Typography variant='h2'>{props.paymentHeaderText}</Typography>
                </p>
                <div className='payment-header-line'></div>
            </div>
        </div>
    );
};

export default PaymentCardMethodHeader;
